(function(){
    'use strict';
    angular.module('app').controller('ConsolidatedShipmentOrdersModal', ConsolidatedShipmentOrdersModal);
    ConsolidatedShipmentOrdersModal.$inject = [
        'shipmentData',
        'ConsolidatedShipmentOrdersTable',
        '$uibModalInstance'
    ];

    function ConsolidatedShipmentOrdersModal(
        shipmentData,
        ConsolidatedShipmentOrdersTable,
        $uibModalInstance
    ){
        const vm = this;
        vm.shipment = shipmentData;
        vm.closeModal = closeModal;
        vm.consolidatedShipmentOrdersTable = new ConsolidatedShipmentOrdersTable(shipmentData).tableData;

        function closeModal(){
            $uibModalInstance.dismiss();
        }
    }
})();


// WEBPACK FOOTER //
// ./js/controllers/shipment/ConsolidateShipmentOrdersModal.js